const setLista = ({ commit }, payload) => {
  commit('SET_LISTA', payload)
}

const setListaLoading = ({ commit }, payload) => {
  commit('SET_LISTA_LOADING', payload)
}

export { setLista, setListaLoading }
